import GitHub from "../../Assets/Images/social/github.svg";
import LinkedIn from "../../Assets/Images/social/linkedin.svg";
import FrontendMentor from "../../Assets/Images/social/frontendmentor.svg";
// import Medium from "../../Assets/Images/social/medium.svg";

const social = [
	{
		name: "Link to GitHub profile",
		link: "https://github.com/subhadip-kundu",
		img: GitHub,
	},
	{
		name: "Link to LinkedIn profile",
		link: "https://www.linkedin.com/in/subhadip-kundu-/",
		img: LinkedIn,
	},
	{
		name: "Link to Frontend Mentor profile",
		link: "https://www.frontendmentor.io/profile/subhadip-kundu",
		img: FrontendMentor,
	},
];

export default social;
